// FixedPortal.jsx
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const FixedPortal = ({ children }) => {
  const portalRootRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // 创建portal容器，放在body后面
    const portalRoot = document.createElement('div');
    portalRoot.id = 'fixed-portal-root';
    portalRoot.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      pointer-events: none;
      z-index: 9999;
      transform: none !important;
    `;

    document.body.parentNode.insertBefore(portalRoot, document.body.nextSibling);
    portalRootRef.current = portalRoot;

    // 创建内部容器
    const container = document.createElement('div');
    container.style.cssText = `
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: none;
    `;
    portalRoot.appendChild(container);
    containerRef.current = container;

    return () => {
      if (containerRef.current) {
        containerRef.current.remove();
      }
      if (portalRootRef.current) {
        portalRootRef.current.remove();
      }
    };
  }, []);

  if (!containerRef.current) return null;

  // 使用portal将children渲染到外部容器
  return createPortal(<div style={{ pointerEvents: 'auto' }}>{children}</div>, containerRef.current);
};

export default FixedPortal;
